import React from 'react';
import type { SetErrorType } from '@/types/common';
import { useRecentlyClaimedCompanies } from '@/hooks/useRecentlyClaimedCompanies';

import { CompaniesRow } from './CompaniesRow';
import { ROUTES } from '@/routes/routes';
import { CompanyCardsSkeletonLoggedout } from '@/components/Skeleton';
import { Company } from '@/types/graphql-types';

const LIMIT = 5;

const RecentlyClaimedCompaniesModule: React.FC<SetErrorType> = ({
  setError,
}) => {
  const { data, loading, error } = useRecentlyClaimedCompanies({
    limit: LIMIT,
  });

  if (loading) return <CompanyCardsSkeletonLoggedout />;

  if (error) setError(!!error);

  const { collection } = data?.companiesRecentlyClaimed ?? {};

  return (
    <CompaniesRow
      title="CP_RECENTLY_CLAIMED_COMPANIES_TITLE"
      showAllLink={ROUTES.recentlyClaimedCompanies}
      totalCaption="CP_RECENTLY_CLAIMED_COMPANIES_CAPTION"
      companies={collection?.map((item) => item?.company as Company) ?? []}
    />
  );
};

export { RecentlyClaimedCompaniesModule };
